import { apiRoutes } from 'routes';
import Fetcher from 'utils/fetcher';
import { TableFilterQueryParams } from 'types/tableFilter';
import { IPurpose } from 'domain/purpose/types';

export type IndexParams = {
  clientId: ID;
  queryParams: TableFilterQueryParams;
};

const PurposesRepository = {
  index({ clientId, queryParams }: IndexParams): Promise<CollectionResponse<'purposes', IPurpose[]>> {
    const url = apiRoutes.apiSiteV1ClientPurposesPath(clientId);
    return Fetcher.get(url, queryParams);
  },
};

export default PurposesRepository;
